const ALLOWED_TAGS = [
  'a',
  'b',
  'blockquote',
  'br',
  'div',
  'em',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'i',
  'img',
  'li',
  'ol',
  'p',
  'source',
  'span',
  'strong',
  'sup',
  'table',
  'tbody',
  'td',
  'th',
  'tr',
  'u',
  'ul',
  'video',
];

const ALLOWED_ATTRS = {
  a: ['href', 'target', 'rel', 'download', 'class'],
  blockquote: ['class'],
  div: ['class'],
  img: ['src', 'alt', 'height', 'width', 'class'],
  p: ['class'],
  source: ['src'],
  span: ['class'],
  table: ['class'],
  td: ['class'],
  th: ['class'],
  tr: ['class'],
  video: ['controls', 'height', 'width', 'class'],
};

const SAFE_URL_PATTERN = /^(https?:|mailto:|tel:|\/|#)/i;

export const escapeHtml = (value = '') => {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

const isSafeUrl = (value = '') => {
  return SAFE_URL_PATTERN.test(String(value).trim());
};

const sanitizeElement = (element) => {
  [...element.children].forEach(sanitizeElement);

  const tagName = element.tagName.toLowerCase();
  if (!ALLOWED_TAGS.includes(tagName)) {
    element.replaceWith(...element.childNodes);
    return;
  }

  [...element.attributes].forEach((attribute) => {
    const attrName = attribute.name.toLowerCase();
    const attrValue = attribute.value;
    const allowedAttrs = ALLOWED_ATTRS[tagName] || [];

    if (!allowedAttrs.includes(attrName) || attrName.startsWith('on')) {
      element.removeAttribute(attribute.name);
      return;
    }

    if ((attrName === 'href' || attrName === 'src') && !isSafeUrl(attrValue)) {
      element.removeAttribute(attribute.name);
    }
  });

  if (tagName === 'a') {
    const href = element.getAttribute('href');
    if (!href || !isSafeUrl(href)) {
      element.removeAttribute('href');
    }
    if (element.getAttribute('target') === '_blank') {
      element.setAttribute('rel', 'noopener noreferrer');
    }
  }
};

export const sanitizeHtml = (dirtyHtml = '') => {
  if (typeof window === 'undefined' || typeof window.DOMParser === 'undefined') {
    return escapeHtml(dirtyHtml);
  }

  const template = document.createElement('template');
  template.innerHTML = String(dirtyHtml);
  [...template.content.children].forEach(sanitizeElement);
  return template.innerHTML;
};
